module.exports = __webpack_public_path__ + "static/media/SY for dummies.a48fc484.jpeg";